import { render, staticRenderFns } from "./TableSelectedTicket.vue?vue&type=template&id=aaaf033e&"
import script from "./TableSelectedTicket.vue?vue&type=script&lang=js&"
export * from "./TableSelectedTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports